/**
 * Pending Save Store (Zustand + localStorage Persist)
 *
 * Persists portfolio data for unauthenticated users attempting to save.
 * Survives OAuth redirects (Google/Microsoft popup and redirect flows).
 * Data is cleared after successful save to Firestore.
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface PendingHolding {
  symbol: string;
  shares: number;
  costBasis?: number;
}

export interface PendingPortfolioSave {
  holdings: PendingHolding[];
  portfolioValue: number;
  riskScore: number;
  riskLevel: string;
  createdAt: string;
}

interface PendingSaveState {
  pendingPortfolio: PendingPortfolioSave | null;

  // Actions
  setPendingPortfolio: (portfolio: PendingPortfolioSave) => void;
  clearPendingPortfolio: () => void;
  hasPendingPortfolio: () => boolean;
}

export const usePendingSaveStore = create<PendingSaveState>()(
  persist(
    (set, get) => ({
      pendingPortfolio: null,

      setPendingPortfolio: (portfolio) => {
        set({ pendingPortfolio: portfolio });
      },

      clearPendingPortfolio: () => {
        set({ pendingPortfolio: null });
      },

      hasPendingPortfolio: () => {
        return get().pendingPortfolio !== null;
      }
    }),
    {
      name: 'indexalpha-pending-portfolio-save',
      partialize: (state) => ({ pendingPortfolio: state.pendingPortfolio })
    }
  )
);
